import { qportalApi } from './qportal-api';
const addBroker = (broker) => {
    return qportalApi.post('broker', broker);
};
const getBrokers = () => {
    return qportalApi.get('broker');
};
const getBrokerById = (id) => {
    return qportalApi.get(`broker/${id}`);
};
const updateBroker = (broker) => {
    return qportalApi.put('broker', { ...broker, brokerId: broker.brokerId });
};
const deleteBroker = (id) => {
    return qportalApi.delete(`broker/${id}`);
};
const BrokerApi = {
    addBroker,
    getBrokers,
    getBrokerById,
    updateBroker,
    deleteBroker
};
export default BrokerApi;
